// extracted by mini-css-extract-plugin
module.exports = {"all":"DirectVideo_all__foXPp","footer":"DirectVideo_footer__3zoFW","link":"DirectVideo_link__2lG8w","timeout":"DirectVideo_timeout__3F-Dd","overlay":"DirectVideo_overlay__2kqQA"};